import ComponentExtension from './ComponentExtension'
export default ComponentExtension.extend({
    props: {
        buttonTop: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        },
        borderless: {
            type: Boolean,
            default: false
        },
        callback: {
            type: Function
        }
    }
})